import './primefine/style';
import FormStructure from './primefine/form_structure';

export default FormStructure;